import React, { useState } from "react";
import { bool, func, number, oneOfType, shape, string } from "prop-types";

const Counter = ({ maxValue, idForm, minValue, hideLabel, label, field, form }) => {
    const [count, setCount] = useState(minValue);

    const { name } = field;

    const update = (newVal) => {
        setCount(newVal);
        form.setFieldValue(name, newVal);
    };

    const substractFromCount = () => {
        update(count - 1);
    };

    const addToCount = () => {
        update(count + 1);
    };

    const idField = `${idForm}.${name}`;

    return (
        <div>
            {!hideLabel && label && (
                <div className="form-group-text">
                    <label className="control-label" id={`label.${idField}`} htmlFor={idField}>
                        {label}
                    </label>
                </div>
            )}
            <div className="counter-container">
                <button
                    type="button"
                    className="counter-button-sub"
                    disabled={count === parseInt(minValue, 10)}
                    onClick={() => substractFromCount()}>
                    -
                </button>
                <input className="counter-input" type="number" min={minValue} max={maxValue} value={count} disabled />
                <button
                    type="button"
                    className="counter-button-add"
                    disabled={count === parseInt(maxValue, 10)}
                    onClick={() => addToCount()}>
                    +
                </button>
            </div>
        </div>
    );
};

Counter.propTypes = {
    maxValue: number.isRequired,
    field: shape({
        onBlur: func,
        onChange: func,
        name: string,
        value: oneOfType([number, string]),
    }).isRequired,
    form: shape({}).isRequired,
    idForm: string,
    minValue: number,
    hideLabel: bool,
    label: string,
};

Counter.defaultProps = {
    idForm: "",
    minValue: 1,
    hideLabel: false,
    label: "",
};

export default Counter;
